import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

import { ToastProvider } from './context/ToastContext.tsx'
import { NetworkErrorBoundary } from './components/NetworkErrorBoundary.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider>
      <NetworkErrorBoundary>
        <App />
      </NetworkErrorBoundary>
    </ToastProvider>
  </StrictMode>,
)
